import { clearToken } from './sessionStorage';

const handleLogout = () => {
    clearToken()
    const event = new CustomEvent('update-token', undefined);
    window.dispatchEvent(event);
}

export { handleLogout }